import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { Suspense } from 'react';
import HeroDescription from '@/components/atoms/HeroDescription';
import Calendar from 'assets/images/calendar.png';
import Sell from 'assets/images/sell.png';
import Camera from 'assets/images/camera.png';
import QrCheckinAction from './QrCheckinAction';
export default function HeartHeroLeftSection(t0) {
  const $ = _c(30);
  const {
    entity,
    isArchived
  } = t0;
  if (!entity) {
    return null;
  }
  const t1 = entity?.themeColor || "#3B9BB6";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      "--theme-color": t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== entity.title) {
    t3 = <h1 className="lg:block lg:text-[#323232] text-white lg:mb-4 mb-3 font-outfit 2xl:text-[3.4em] xl:text-[2.8em] lg:text-[1.6em] md:text-[1.2em] text-lg font-semibold leading-[1em]">{entity.title}</h1>;
    $[2] = entity.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== entity.description) {
    t4 = entity.description && <HeroDescription description={entity.description} className="lg:text-[#626262] text-[#DCDCDC] lg:text-lg md:text-sm text-[0.65em]" mobileLimit={90} />;
    $[4] = entity.description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== entity.artistName) {
    t5 = entity.artistName && <Link href="#artist-spotlight" className="inline-flex lg:w-auto w-1/2 sm:max-w-[12em] max-w-[10em] items-start xl:gap-3 gap-2 lg:text-[#626262] text-[#DCDCDC] xl:text-lg lg:text-base md:text-sm text-[13px] font-normal leading-[1.33em]"><span className="lg:h-5 h-4 flex items-center shrink-0"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" className="lg:h-4 lg:w-4.5 h-3.5 w-3.5 flex shrink-0 text-[#AAAAAA]"><path d="M3.096 16.6418C2.52383 16.6418 1.95808 16.5161 1.39875 16.2648C0.83925 16.0134 0.373 15.6775 0 15.257C0.382 15.148 0.7435 14.9163 1.0845 14.5618C1.4255 14.2074 1.596 13.7341 1.596 13.1418C1.596 12.4429 1.838 11.8516 2.322 11.3678C2.806 10.8838 3.39733 10.6418 4.096 10.6418C4.79483 10.6418 5.38617 10.8838 5.87 11.3678C6.354 11.8516 6.596 12.4429 6.596 13.1418C6.596 14.1043 6.25333 14.9282 5.568 15.6135C4.8825 16.299 4.0585 16.6418 3.096 16.6418ZM3.096 15.1418C3.646 15.1418 4.11683 14.9459 4.5085 14.5543C4.90017 14.1626 5.096 13.6918 5.096 13.1418C5.096 12.8584 5.00017 12.6209 4.8085 12.4293C4.61683 12.2376 4.37933 12.1418 4.096 12.1418C3.81267 12.1418 3.57517 12.2376 3.3835 12.4293C3.19183 12.6209 3.096 12.8584 3.096 13.1418C3.096 13.5251 3.05017 13.8751 2.9585 14.1918C2.86683 14.5084 2.746 14.8084 2.596 15.0918C2.67933 15.1251 2.76267 15.1418 2.846 15.1418H3.096ZM8.40375 11.084L6.173 8.85325L14.7383 0.288C14.9216 0.104667 15.1508 0.00883333 15.4258 0.0005C15.7008 -0.00783333 15.9383 0.088 16.1383 0.288L16.969 1.11875C17.169 1.31875 17.269 1.55208 17.269 1.81875C17.269 2.08542 17.169 2.31875 16.969 2.51875L8.40375 11.084Z" fill="#C4C4C4" /></svg></span>by {entity.artistName}</Link>;
    $[6] = entity.artistName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== entity.directionsUrl || $[9] !== entity.locationName) {
    t6 = entity.locationName && <div className="lg:w-auto w-1/2 max-w-[12em]"><Link href={entity.directionsUrl || "/"} className="inline-flex items-start xl:gap-3 gap-2 lg:text-[#626262] text-[#DCDCDC] xl:text-lg lg:text-base md:text-sm text-[13px] font-normal leading-[1.3em]" target="_blank" rel="noopener noreferrer"><span className="flex lg:h-5 h-4 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none" className="lg:h-4.5 lg:w-4.5 h-3.5 w-3.5 flex shrink-0 text-[#AAAAAA]"><path d="M7.548 16.3046C9.50433 14.6262 11.0014 13.0164 12.0393 11.4751C13.0771 9.93376 13.596 8.58379 13.596 7.42517C13.596 5.67812 13.0168 4.2419 11.8585 3.1165C10.7002 1.9911 9.26333 1.4284 7.548 1.4284C5.83267 1.4284 4.39583 1.9911 3.2375 3.1165C2.07917 4.2419 1.5 5.67812 1.5 7.42517C1.5 8.58379 2.01892 9.93376 3.05675 11.4751C4.09458 13.0164 5.59167 14.6262 7.548 16.3046ZM7.548 17.6719C7.35317 17.6719 7.15833 17.6397 6.9635 17.5754C6.7685 17.5108 6.59217 17.411 6.4345 17.2759C5.53717 16.4833 4.69742 15.6672 3.91525 14.8273C3.13325 13.9877 2.4535 13.1483 1.876 12.3091C1.29833 11.4699 0.84125 10.6381 0.50475 9.81381C0.16825 8.98933 0 8.19311 0 7.42517C0 5.21365 0.746417 3.42325 2.23925 2.05395C3.73225 0.684649 5.50183 0 7.548 0C9.59417 0 11.3637 0.684649 12.8567 2.05395C14.3496 3.42325 15.096 5.21365 15.096 7.42517C15.096 8.19311 14.9277 8.98773 14.5912 9.80902C14.2547 10.6305 13.7993 11.4623 13.225 12.3045C12.6505 13.1467 11.9722 13.9862 11.1902 14.8228C10.4082 15.6596 9.5685 16.4741 8.671 17.2665C8.51567 17.4017 8.33908 17.503 8.14125 17.5706C7.94358 17.6381 7.74583 17.6719 7.548 17.6719ZM7.54975 8.97503C8.04725 8.97503 8.47258 8.80525 8.82575 8.46568C9.17908 8.12611 9.35575 7.71794 9.35575 7.24117C9.35575 6.7644 9.17858 6.35671 8.82425 6.01809C8.46992 5.67964 8.04392 5.51042 7.54625 5.51042C7.04875 5.51042 6.62342 5.6802 6.27025 6.01977C5.91692 6.35934 5.74025 6.76759 5.74025 7.24452C5.74025 7.72129 5.91742 8.1289 6.27175 8.46735C6.62608 8.80581 7.05208 8.97503 7.54975 8.97503Z" fill="#AAAAAA" /></svg></span><span className="underline">{entity.locationName}</span></Link></div>;
    $[8] = entity.directionsUrl;
    $[9] = entity.locationName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== entity.sponsor || $[12] !== entity.sponsorUrl) {
    t7 = entity.sponsor && <div className="text-[#626262] xl:text-lg text-base font-normal leading-[1.3em] relative lg:block hidden"><span className="block text-xs absolute bottom-full pb-0.5">Patron Partner</span>{entity.sponsorUrl && <Link href={entity.sponsorUrl} target="_blank" rel="noopener noreferrer" className="underline">{entity.sponsor}</Link>}{!entity.sponsorUrl && entity.sponsor}</div>;
    $[11] = entity.sponsor;
    $[12] = entity.sponsorUrl;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex 2xl:gap-6 xl:gap-4 gap-3 2xl:mt-10 xl:mt-8 lg:mt-6 md:mt-5 mt-4 text-[#626262] font-outfit lg:text-lg text-base font-normal leading-[1.5em]">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t8) {
    t9 = <div className="2xl:mb-9.5 xl:mb-8 lg:mb-7.5 mb-6 lg:border-b lg:border-[#D9D9D9] 2xl:pb-9 xl:pb-7 lg:pb-5">{t4}{t8}</div>;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== entity.communityId || $[22] !== entity.id || $[23] !== isArchived) {
    t10 = !isArchived && <><div className="lg:hidden block h-px bg-[#757575] mb-5 backdrop-blur-[10px] -mx-5"><span className="sr-only">border</span></div><div className="flex justify-around sm:mx-0 mx-[-15px]"><Suspense fallback={null}><QrCheckinAction label="Check in Now" actionClass="lg:!hidden !flex" heartId={entity.id} /></Suspense>{entity.communityId && <><Action href="#communityEvents" label="Events & Attractions" icon={<Image src={Calendar} alt="Calendar icon" className="h-5" />} /><Action href="#communityPromotions" label="Promotions" icon={<Image src={Sell} alt="Promotions icon" className="h-5 w-auto" />} /></>}<Action href="#uploadPhotos" label="Upload Photos" icon={<Image src={Camera} alt="camera icon" className="h-4 w-auto" />} /></div></>;
    $[21] = entity.communityId;
    $[22] = entity.id;
    $[23] = isArchived;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t2 || $[27] !== t3 || $[28] !== t9) {
    t11 = <div className="lg:max-w-[27.5em] max-w-full lg:p-0 p-5 lg:bg-transparent bg-black/20 lg:backdrop-blur-0 lg:backdrop-blur-none backdrop-blur-[10px] rounded-0 rounded-2xl" style={t2}>{t3}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t2;
    $[27] = t3;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}

/** Small pill button used in the action row */
function Action(t0) {
  const $ = _c(9);
  const {
    href,
    label,
    icon,
    ActionClass: t1
  } = t0;
  const ActionClass = t1 === undefined ? "" : t1;
  const t2 = `flex flex-col items-center gap-3 lg:px-3 px-1 lg:pb-3 text-center w-1/4 ${ActionClass}`;
  let t3;
  if ($[0] !== icon) {
    t3 = <span className="flex h-12 w-12 items-center justify-center rounded-full text-white bg-[var(--theme-color)]">{icon}</span>;
    $[0] = icon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label) {
    t4 = <span className="lg:text-[#323232] max-w-20 text-white leading-[1.12em] lg:text-base text-[0.65em] font-semibold">{label}</span>;
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== href || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <Link href={href} className={t2}>{t3}{t4}</Link>;
    $[4] = href;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}